export class LinearObjectPool {
    constructor(makeT, size = 64) {
        this.usedIndex = 0;
        this.makeT = makeT;
        this.items = [...Array(size)].map(() => makeT());
    }
    pop() {
        if (this.usedIndex + 1 >= this.items.length) {
            this.items.push(this.makeT());
            window.usedSize = this.items.length;
        }
        return this.items[this.usedIndex++];
    }
    done() {
        for (let i = this.usedIndex; i >= 0; i--) {
            this.items[i].clean();
        }
        this.usedIndex = 0;
    }
    clean() {
        this.done();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/LinearObjectPool.ts
// module id = 12
// module chunks = 0